<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md11>
              <v-card title>
                  <v-card-text>
                    <v-stepper v-model="e1">
                      <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1"> Distritos </v-stepper-step>
                        <v-divider />
                        <v-stepper-step :complete="e1 > 2" step="2"> Municipios </v-stepper-step>
                        <v-divider />
                        <v-stepper-step :complete="e1 > 3" step="3"> Secciones </v-stepper-step>
                      </v-stepper-header>

                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <v-card
                            class="mb-12"
                            color="grey lighten-1">
                            <v-card-text>
                              <p class="font-weight-bold pa-2">Seleccione un Distrito.</p>
                              <v-radio-group v-model="distri" row>
                                <v-radio label="Distrito Federales" value="Federales"></v-radio>
                                <v-radio label="Distrito Estatales" value="Estatales"></v-radio>
                              </v-radio-group>
                              <hr>
                              <v-row dense>
                                <v-col cols="6">
                                  <v-treeview v-if="distri == 'Federales'"
                                    v-model="access.assignments.distritos.federal"
                                    selectable
                                    :items="federal"
                                    return-object>
                                  </v-treeview>
                                  <v-treeview v-else
                                    v-model="access.assignments.distritos.estatal"
                                      selectable
                                      :items="estatal"
                                      return-object>
                                  </v-treeview>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                          <v-btn color="primary" @click="nextstep(1)"> Continuar </v-btn>
                          <v-btn text @click="cancel"> Cancelar</v-btn>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-card
                            class="mb-12"
                            color="grey lighten-1">
                            <v-card-text>
                              <v-row dense>
                                <v-col cols="6">
                                  <v-treeview
                                    v-model="access.assignments.municipios"
                                      selectable
                                      :items="municipios"
                                      return-object>
                                  </v-treeview>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                          <v-btn color="primary" @click="nextstep(2)"> Continuar </v-btn>
                          <v-btn text @click="cancel"> Cancelar</v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                          <v-card
                            class="mb-12">
                            <v-card-text>
                              <v-row dense>
                                <v-col cols="12">
                                  <v-checkbox
                                    v-model="checkbox"
                                    label="Seleccionar todos"
                                    color="success"
                                    @change="selectedAll" >
                                  </v-checkbox>
                                </v-col>

                                <v-col cols="4" md="1" sm="2" v-for="(seccion, s) in selection" :key="s">
                                  <v-alert border="top" dense>
                                    <v-checkbox
                                      v-model="access.assignments.secciones"
                                      :label="seccion.seccion"
                                      :value="seccion.id"
                                      return-object
                                      color="success">
                                    </v-checkbox>
                                  </v-alert>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                          <v-btn color="primary" @click="saveAccess"> Guardar </v-btn>
                          <v-btn text @click="cancel"> Cancelar</v-btn>
                        </v-stepper-content>

                      </v-stepper-items>

                    </v-stepper>
                  </v-card-text>
              </v-card>
            </v-flex>
        </v-layout>
</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import router from '@/router'
export default {
  data: () => ({
    e1: 1,
    distri: 'Federales',
    columnas: 20,
    filas: 10,
    access: {
      id: 0,
      assignments: {
        municipios: [],
        secciones: [],
        distritos: {
          federal: [],
          estatal: []
        }
      }
    },
    person: {},
    federal: [],
    estatal: [],
    municipios: [],
    selection: [],
    rol_id: 0,
    ids: [],
    checkbox: false
  }),
  components: {
  },
  mounted () {
    if (this.$route.params.id) {
      this.access.id = this.$route.params.id
    }
    this.postUserUrl('usr.list')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction', 'getUrlServicesSecoundAction', 'getUrlServicesAction', 'postUrlServicesListAction']),
    postUserUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: { id: this.access.id } })
        this.getDistritosUrl('distr.est-fed')
      } else {
        this.getUrlServices()
      }
    },
    getDistritosUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServicesSecoundAction(router)
      } else {
        this.getUrlServices()
      }
    },

    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.getUrlServicesAction({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    postUrl (objet) {
      const router = this.get_urls[objet]
      // router.data = { ids: this.ids }
      this.postUrlServicesListAction({ url: router, data: { ids: this.ids } })
    },
    postUrlSave (objet) {
      const router = this.get_urls[objet]
      // router.data = this.access
      this.postUrlServicesListAction({ url: router, data: this.access })
    },
    nextstep (i) {
      if (i === 1) {
        if (this.distri === 'Federales' && this.access.assignments.distritos.federal.length > 0) {
          this.ids = []
          this.access.assignments.distritos.federal.map(i => {
            this.ids.push(i.id)
          })
          this.access.assignments.distritos.estatal = []
          this.postUrl('mun.byDistritoFederal')
          this.e1 = 2
        } else if (this.access.assignments.distritos.estatal.length > 0) {
          this.ids = []
          this.access.assignments.distritos.estatal.map(i => {
            this.ids.push(i.id)
          })
          this.access.assignments.distritos.federal = []
          this.e1 = 2
          this.postUrl('mun.byDistritoEstatal')
        } else {
          this.$swal({
            type: 'warning',
            icon: 'warning',
            title: 'Warning!',
            text: 'Debe Seleccionar un distrito'
          })
        }
      } else if (i === 2) {
        if (this.access.assignments.municipios.length > 0) {
          this.ids = []
          this.access.assignments.municipios.map(i => {
            this.ids.push(i.id)
          })
          this.e1 = 3
          this.postUrl('secc.getsecciones')
        } else {
          this.$swal({
            type: 'warning',
            icon: 'warning',
            title: 'Warning!',
            text: 'Debe Seleccionar un almenos un municipio'
          })
        }
      }
    },
    selectedAll () {
      if (this.checkbox) {
        this.access.assignments.secciones = this.selection.map(item => {
          return item.id
        })
      } else {
        this.access.assignments.secciones = []
      }
    },
    saveAccess () {
      this.e1 = 4
      this.postUrlSave('usr.upd-assignments')

      /*
      if (this.access.assignments.secciones.length > 0) {
      } else {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Warning!',
          text: 'Debe Seleccionar un o varias secciones'
        })
      } */
    },
    cancel () {
      router.push({ name: 'ViewUsers' })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATAS_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object', 'get_objects', 'get_objectSecound'])
  },
  watch: {
    get_urls (val) {
      if (this.e1 === 1) {
        this.postUserUrl('usr.list')
      }
    },
    get_objects (val) {
      if (val) {
        if (this.e1 === 2) {
          this.municipios = []
          const children = val.map(item => {
            return { id: item.id, key: item.clave, name: item.nombre }
          })
          this.municipios.push({ id: 0, name: 'MUNICIPIOS', children: children })
          if (this.person.assignments !== '') {
            this.access.assignments.municipios = this.person.assignments.municipios
          }
        } else if (this.e1 === 3) {
          this.selection = val
          if (this.person.assignments !== '') {
            this.access.assignments.secciones = this.person.assignments.secciones
          }
        } else if (this.e1 === 4) {
          if (val.message) {
            this.$swal({
              type: 'error',
              icon: 'error',
              title: 'error!',
              text: val.message
            })
            return
          }
          this.$swal({
            type: 'success',
            icon: 'success',
            title: 'Exitoso!',
            text: 'Aginaciones agregardo correctamente'
          })
          this.cancel()
        }
      }
    },
    get_object (val) {
      if (val) {
        if (val.length === 1) {
          this.person = val[0]
        }
      }
    },
    get_objectSecound (val) {
      if (val) {
        this.federal = []
        const federal = val.FEDERALES.map(item => {
          return { id: item.id, name: item.nombre }
        })
        this.federal.push({ id: 0, name: 'DISTRITOS FEDERALES', children: federal })

        // Estatales
        this.estatal = []
        const estatal = val.ESTATALES.map(item => {
          return { id: item.id, name: item.nombre }
        })
        this.estatal.push({ id: 1, name: 'DISTRITOS ESTATALES', children: estatal })
        if (this.person.assignments !== '') {
          this.access.assignments.distritos.federal = this.person.assignments.distritos.federal
          this.access.assignments.distritos.estatal = this.person.assignments.distritos.estatal
        }
      }
    }

  },
  beforeDestroy () {
    this.CLEAR_DATAS_MAIN()
  }

}
</script>

<style>

</style>
